module.exports = __webpack_public_path__ + "img/34.dcf0eefd.jpg";